import PropTypes from 'prop-types';
import React from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @param {PropTypes.InferProps<typeof propTypes>} props
 */
const CarouselItemPersonDetailPage = ({
    image = null,
    listingImage = null,
    role = null,
    title = null,
    url = null
}) => {
    return (
        <div className='h-full -ml-15 expand-interaction focus-within:bg-peach hover:bg-peach p-30'>
            <a
                className='block'
                href={url}>
                {(image || listingImage) && (
                    <img
                        alt={listingImage?.alt || image?.alt}
                        className='object-cover aspect-square w-full'
                        height={listingImage?.height || image?.height}
                        loading='lazy'
                        src={listingImage?.px2 || image?.px2}
                        width={listingImage?.width || image?.width} />
                )}

                {title && (
                    <p className='type-style-3 mt-20 md:mt-30'>
                        {title}
                    </p>
                )}

                {role && (
                    <p className='type-style-4 mt-20'>
                        {role}
                    </p>
                )}
            </a>
        </div>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

CarouselItemPersonDetailPage.propTypes = {
    image: PropTypes.object.isRequired,
    listingImage: PropTypes.object,
    role: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
};

export default CarouselItemPersonDetailPage;
